module.exports = __webpack_public_path__ + "img/delete_icon.c5b82ceb.svg";